// extracted by mini-css-extract-plugin
export default {"select":"Select_select__mst-X","invalid":"Select_invalid__0-pRY"};